import DOMPurify from 'dompurify';

const ALLOWED_TAGS = [
	'a',
	'b',
	'blockquote',
	'br',
	'caption',
	'code',
	'col',
	'colgroup',
	'del',
	'div',
	'em',
	'h1',
	'h2',
	'h3',
	'h4',
	'h5',
	'h6',
	'hr',
	'i',
	'img',
	'li',
	'ol',
	'p',
	'pre',
	's',
	'span',
	'strong',
	'table',
	'tbody',
	'td',
	'th',
	'thead',
	'tr',
	'u',
	'ul',
];

const ALLOWED_ATTRS = [
	'align',
	'alt',
	'border',
	'cellpadding',
	'cellspacing',
	'class',
	'color',
	'colspan',
	'dir',
	'height',
	'href',
	'id',
	'rowspan',
	'src',
	'style',
	'target',
	'title',
	'valign',
	'width',
];

const SAFE_DATA_IMAGE_RE = /^data:image\/(png|jpeg|gif|webp);base64,/i;

function isSafeUri(value: string): boolean {
	const lower = value.trim().toLowerCase();
	if (lower.startsWith('javascript:')) return false;
	if (lower.startsWith('data:')) return SAFE_DATA_IMAGE_RE.test(value);
	return true;
}

const purify = DOMPurify(window);

purify.addHook('afterSanitizeAttributes', node => {
	if (node.tagName === 'A') {
		const href = node.getAttribute('href');
		if (href !== null && !isSafeUri(href)) {
			node.removeAttribute('href');
		}
		node.setAttribute('target', '_blank');
		node.setAttribute('rel', 'noopener noreferrer');
	}

	if (node.tagName === 'IMG') {
		const src = node.getAttribute('src');
		if (src === null) {
			node.parentNode?.removeChild(node);
			return;
		}
		const trimmed = src.trim();
		const isLocalApi = trimmed.startsWith('/api/');
		const isSafeData = SAFE_DATA_IMAGE_RE.test(trimmed);
		const isHttps = trimmed.startsWith('https://');
		const isHttp = trimmed.startsWith('http://');
		if (!isLocalApi && !isSafeData && !isHttps && !isHttp) {
			node.parentNode?.removeChild(node);
		}
		// Local /api/ srcs are already signed server-side; leave them as-is.
	}
});

export function sanitizeMessageHtml(html: string): string {
	return purify.sanitize(html, {
		ALLOWED_TAGS,
		ALLOWED_ATTR: ALLOWED_ATTRS,
	});
}
